import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { Store } from '@src/store';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { securityActions } from '@src/store/reducers/securityReducer';
import { userActions } from '@src/store/reducers/userReducer';
import _ from 'lodash';
// import { DialogManagerService } from '@src/services';
// import { userActions } from '@src/store/reducers/userReducer';

// import $ from 'jquery';

@Component({
    selector: 'group-mapping-oidc',
    template: require('./group-mapping-oidc.component.html'),
    styles: [require('./group-mapping-oidc.component.scss')]
})
export class GroupMappingOidc implements OnInit {
    public hasItems = false;
    public selectedDomain: any;
    public OidcConf:any;
    public roles;
    public ignoreUnmanaged:boolean;
    public projects;
    public projectsFromService
    public projectGroups;
    @Input() public groupsMapping: any;
    @Output() public onUpdateUnmanaged = new EventEmitter();
    @Output() public onUpdateMapping = new EventEmitter();
    public unSubscribe: any;

    constructor(
        private store: Store,
        @Inject('$scope') private $scope: any) {
        this.$scope.$watch(() => this.groupsMapping, (newValue: any, oldValue: any) => {
            const state = this.store.getState();
            const stateNotExist = state || !state.user || state.user.roles || state.user.projectGroups;
            if (newValue === oldValue || !stateNotExist) {
                return;
            }
            this.mergeRoles();
            this.mergeProjectGroups();
            this.mergeProjects();
        });
    }

    public async ngOnInit() {
        //console.log(this.ignoreUnmanaged)
        this.projectsFromService = await this.store.dispatch({ type: projectsActions.GET_PROJECTS })
        if (this.projectsFromService) {
            this.projectsFromService.forEach
            this.projectsFromService.forEach((x: any) => {
                x['group'] = '';
            });
            this.mergeProjects();
        }
        if (!this.store.getState().user.roles) {
            this.store.dispatch({ type: userActions.GET_ROLES });
        } else {
            this.mergeRoles();
        }
        if(!this.store.getState().user.projectGroups){
            this.store.dispatch({ type: userActions.GET_PROJECT_GROUPS });
        }
        else {
            this.mergeProjectGroups();
        }
        this.unSubscribe = this.store.subscribe(() => {
            if (this.projectsFromService) {
                this.mergeProjects();
            }
            if (this.store.getState().user.roles) {
                this.mergeRoles();
            }
            if (this.store.getState().user.projectGroups) {
                this.mergeProjectGroups();
            }
        });
    }

    public ngOnDestroy() {
        this.unSubscribe();
    }

    private async mergeRoles() {
        if(this.groupsMapping == undefined){
            const action = { type: securityActions.GET_OIDC_COfIGURATIONS};
            const response = await this.store.dispatch(action);
            this.groupsMapping = response.data
        }
        const hasDomainRoles = this.groupsMapping?.GroupsMapping;
        //console.log(hasDomainRoles)
        let RolesMapping = hasDomainRoles.filter(x => x.objectType == 0)
        this.roles = this.mergeMapping(RolesMapping, _.cloneDeep(this.store.getState().user.roles));
    }

    public setDataConfig(fieldName:string,flag:boolean){
        let newInser = {fieldName:fieldName,data:flag} 
        this.onUpdateUnmanaged.emit(newInser)
   }

    private async mergeProjects() {
        if(this.groupsMapping == undefined){
            const action = { type: securityActions.GET_OIDC_COfIGURATIONS};
            const response = await this.store.dispatch(action);
            this.groupsMapping = response.data
        }
        const hasDomainRoles = this.groupsMapping?.GroupsMapping;
        let RolesMapping = hasDomainRoles.filter(x => x.objectType == 2)
        this.projects = this.mergeProjcts(RolesMapping, _.cloneDeep(this.projectsFromService));
    }

    private async mergeProjectGroups() {
        if(this.groupsMapping == undefined){
            const action = { type: securityActions.GET_OIDC_COfIGURATIONS};
            const response = await this.store.dispatch(action);
            this.groupsMapping = response.data
        }
        const hasDomainRoles = this.groupsMapping?.GroupsMapping;
        let ProjectGroupMapping = hasDomainRoles.filter(x => x.objectType == 1)
        this.projectGroups = this.mergeMapping(ProjectGroupMapping , this.getProjectGroupsFiltered());
    }

    private mergeMapping(domainBoundMapping: any, storeData: any) {
        //console.log(storeData)
        if (domainBoundMapping && storeData) {
            domainBoundMapping.forEach((x: any) => {
                storeData.find(({ id }) => x.objectId === id).group = x.groupName;
            });
        }
        return storeData;
    }

    private mergeProjcts(domainBoundMapping: any, storeData: any) {
        //console.log(storeData)
        if (domainBoundMapping && storeData) {
            domainBoundMapping.forEach((x: any) => {
                storeData.find(({ id }) => x.objectId === id).group = x.groupName;
            });
        }
        return storeData;
    }

    private getProjectGroupsFiltered() {
        const userState = this.store.getState().user;
        if (userState && userState.projectGroups) {
            return _.cloneDeep(userState.projectGroups.filter(({ id }) => id !== 1));
        }
        return [];
    }

    public changeMapping(id: any, object: any,text:string) {
           let objectOidc = {
             groupName: text,
             objectType: Number(id),
             objectId: object.id }
             this.onUpdateMapping.emit(objectOidc)
    }
   

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/oidc-configuration/group-mapping-oidc/group-mapping-oidc.component.ts